define('views/errors/AlertView',['require','jquery','underscore','evertrue','backbone','ET/ETView'],function(require) {
  var $, Backbone, ETView, EverTrue, _;
  $ = require("jquery");
  _ = require("underscore");
  EverTrue = require("evertrue");
  Backbone = require("backbone");
  ETView = require("ET/ETView");
  return ETView.extend({
    alert: function(alert_type, options) {
      var $alert, fade, header, message, timeout, type;
      if (options == null) {
        options = {};
      }
      type = "alert-block";
      header = options.header, timeout = options.timeout, message = options.message;
      timeout || (timeout = 3000);
      header || (header = "");
      message || (message = "");
      switch (alert_type) {
        case "success":
          type = "alert-success";
          header || (header = "Success");
          break;
        case "error":
          type = "alert-error";
          header || (header = "Error");
          break;
        case "warning":
          type = "alert-warning";
          header || (header = "Warning");
          break;
        case "info":
          type = "alert-info";
      }
      $alert = $(".alert");
      if (!$alert.length) {
        $alert = $("<div class='alert alert-block'>" + "<button type='button' class='close' data-dismiss='alert'>&times</button>" + "<h4></h4><p></p></div>");
        $("body").append($alert);
      }
      $alert.removeClass().addClass("alert alert-block " + type);
      $("h4", $alert).text(header);
      $("p", $alert).html(message);
      fade = function(direction, duration, cb) {
        return $alert["fade" + direction]("slow", cb);
      };
      return fade("In", setTimeout(function() {
        return fade("Out", function() {
          return $alert.remove();
        });
      }, timeout));
    },
    displayCustomMessage: function(message) {
      if (message === "Changing the privatized_source is not allowed, it is owned by: COMMUNITY") {
        message = "Overriding a user's preference to hide their own profile is not permitted.";
      }
      return this.alert("error", {
        message: message
      });
    },
    globalErrorCallback: function(options, xhr, textStatus, errorThrown) {
      var message, msg, raven_msg, resp, _ref, _ref1;
      if (options == null) {
        options = {};
      }
      resp = EverTrue.jsonParse(xhr.responseText, {});
      message = ((_ref = resp.meta) != null ? _ref.message : void 0) || "Sorry there was an error. Please try again soon.";
      if (!options.suppressGlobalErrorMsg) {
        if ((raven_msg = ((_ref1 = resp.meta) != null ? _ref1.message : void 0) || resp.message || resp.error)) {
          Raven.captureMessage(raven_msg, {
            tags: {
              type: "api error"
            }
          });
        }
        if (xhr.status === 401) {
          return EverTrue.Session.renew();
        } else if (xhr.status === 403) {
          message = resp.error || "User is not authorized for this organization.";
          this.alert("error", {
            message: message,
            header: "Please Sign In"
          });
          return EverTrue.logout({
            timeout: 2000
          });
        } else if ((msg = resp.message || resp.error)) {
          return this.displayCustomMessage(msg);
        } else if (message) {
          return this.alert("error", {
            message: message
          });
        }
      }
    }
  });
});

//# sourceMappingURL=AlertView.js.map
;
